var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "indigo",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.049,69.426c-91.066-91.918-239.404-92.609-331.322-1.542s-92.609,239.404-1.542,331.322  c0.71,0.716,1.424,1.428,2.143,2.135l83.98,77.548c44.886,43.938,116.602,44.127,161.719,0.426l85.023-78.57  C513.538,309.253,513.538,160.919,422.049,69.426L422.049,69.426z M384.181,288.332c0,29.407-23.839,53.246-53.246,53.246H181.846  c-29.407,0-53.246-23.839-53.246-53.246v-71.818c0-20.946,10.265-40.562,27.475-52.501l63.895-44.322  c21.918-15.146,50.922-15.146,72.841,0l63.895,44.322c17.21,11.939,27.475,31.555,27.475,52.501V288.332z M341.584,216.513v71.818  c0,5.881-4.768,10.649-10.649,10.649h-31.948v-42.597c0-11.763-9.536-21.298-21.298-21.298h-42.597  c-11.763,0-21.298,9.536-21.298,21.298v42.597h-31.948c-5.881,0-10.649-4.768-10.649-10.649v-71.818  c-0.002-6.984,3.42-13.526,9.158-17.507l63.895-44.322c7.312-5.028,16.968-5.028,24.28,0l63.895,44.322  C338.164,202.987,341.586,209.529,341.584,216.513z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.0af28ac5e5b3300607c5ac2155b75036.svg";
export { ForwardRef as ReactComponent };